import script from "./EditThresholdModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditThresholdModal.vue?vue&type=script&setup=true&lang=js"

import "./EditThresholdModal.vue?vue&type=style&index=0&id=1b55ce96&scoped=true&lang=css"
import "./EditThresholdModal.vue?vue&type=style&index=1&id=1b55ce96&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b55ce96"]])

export default __exports__